<template>
  <div class="card" :class="cardClass">
    <div class="card-content">
      <div class="content columns">
        <div v-if="section.docCount" class="column">
          <router-link
            :to="{
              name: 'gisogdSectionDocs',
              params: { gisogdSection: section.id },
            }"
            class="is-link has-text-black"
            >{{ section.name }}</router-link
          >
        </div>
        <div v-else class="column">{{ section.name }}</div>
      </div>
      <div class="indicators">
        <nav class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <span class="has-text-grey">Количество</span>
              <span class="tag is-rounded value">{{ section.docCount }}</span>
            </div>
          </div>
          <div class="level-right">
            <div class="">
              <img
                src="../../assets/svg/info.svg"
                :title="section.description"
              />
            </div>
          </div>
        </nav>
      </div>
    </div>
    <footer class="card-footer" :class="{ notempty: section.docCount }">
      <router-link
        v-if="section.docCount"
        :to="{
          name: 'gisogdSectionDocs',
          params: { gisogdSection: section.id },
        }"
        class="is-link"
      >
        Подробнее
      </router-link>
      <span v-else class="empty"></span>
    </footer>
  </div>
</template>
<script>
export default {
  props: {
    section: { required: true },
    cardClass: {
      default: "",
      type: String,
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/sass/main.scss";

.card-footer {
  padding: 25px;
  justify-content: center;
  margin-left: 25px;
  margin-right: 25px;
}

.card-footer.notempty {
  border-top: 1px solid #efefef;
}

.card-footer .empty {
  height: 1.5rem;
}

.card-content {
  flex-grow: 1;
  padding: 21px 25px 0px 25px !important;
  display: flex;
  flex-direction: column;
}

.card {
  display: flex;
  flex-direction: column;
  border: 1px solid #efefef;
  box-sizing: border-box;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  border-bottom: 4px solid $blue;
}

.indicators {
  padding: 8px 0px;
  flex-grow: 1;
}

.content {
  color: #000;
  margin-bottom: 12px !important;
  height: 100%;
  position: relative;
}

.value {
  margin-left: 5px;
}
</style>